import React, { useState } from "react"
import styled from "styled-components"
import {
  StandardContainer,
  VideoModal,
  PrismicImage,
  SectionWrapper,
} from "../../common"
import PlayIcon from "../../../svg/play.svg"

const StyledVideoBlock = styled(StandardContainer)`
  position: relative;
  margin-top: 2rem;
`

const StyledPlayButton = styled.button`
  width: calc(100% - ${(props) => props.theme.padding.hMobile} * 2);
  height: 100%;
  position: absolute;
  padding: 0;
  top: 0;
  left: ${(props) => props.theme.padding.hMobile};
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  > svg {
    width: 80px;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    width: calc(100% - ${(props) => props.theme.padding.hDesk} * 2);
    left: ${(props) => props.theme.padding.hDesk};
  }
`

export const VideoBlock = ({
  poster_image,
  full_video,
  anchor_id,
  block_background,
}) => {
  const [video, setVideo] = useState(null)
  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledVideoBlock className="video-block" $wrappedStandard id={anchor_id}>
        <StyledPlayButton
          className="play-button"
          onClick={() => setVideo(full_video)}
        >
          <PlayIcon />
        </StyledPlayButton>
        <PrismicImage {...poster_image} />
      </StyledVideoBlock>
      <VideoModal video={video} onClose={() => setVideo(null)} />
    </SectionWrapper>
  )
}
